import { OrdersRatingStore } from '../OrdersRatingScreen/store/ordersRatingStore';
import { SCREENS } from '~/constants/screens';
import { OrdersHistoryStore } from '~/mobx/ordersHistoryStore/ordersHistoryStore';
import { CallCenterStore } from '~/mobx/ordersStore/callCenterStore';
import { LiveOrdersStore } from '~/mobx/ordersStore/liveOrdersStore';

const getOrdersPath = (parentStore: LiveOrdersStore | CallCenterStore | OrdersHistoryStore | OrdersRatingStore) => {
  if (parentStore instanceof LiveOrdersStore) {
    return SCREENS.LIVE_ORDERS();
  }

  if (parentStore instanceof CallCenterStore) {
    return SCREENS.CALLCENTER();
  }

  if (parentStore instanceof OrdersHistoryStore) {
    return SCREENS.HISTORY();
  }
  return SCREENS.ROOT();
};

export default getOrdersPath;
